import { donationsApi } from '../api/donationsApi'

export const uploadDonationDepositReceipt = async (
  donationId: string,
  depositDate: string,
  file: File,
  notes?: string,
) => {
  try {
    const { data } = await donationsApi.uploadDonationDepositReceipt(
      donationId,
      depositDate,
      file,
      notes,
    )
    return data
  } catch (error) {
    console.error(`Error uploading donation deposit receipt: `, error)
    throw error
  }
}
